import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 bg-white">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-4">Last updated: July 14, 2025</p>

      <p className="mb-4">By accessing or using <strong>Jivan Gaming</strong>, you agree to these Terms and Conditions.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">General:</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>This website sells digital products (gaming courses).</li>
        <li>You must be 18+ or have parental permission to use our services.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Payments:</h2>
      <p className="mb-4">All payments are final and processed securely. Ensure correct payment details and product selection before confirming an order.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Intellectual Property:</h2>
      <p className="mb-4">All content (videos, materials) is the property of <strong>Jivan Gaming</strong> and cannot be copied, shared, or resold.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Limitation of Liability:</h2>
      <p className="mb-4">We are not responsible for any damages arising from misuse of our digital content.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Termination:</h2>
      <p className="mb-4">We reserve the right to suspend access if any policy is violated.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us:</h2>
      <p>Email: <a href="mailto:jivanpawar023@gmail.com" className="text-blue-500 underline">jivanpawar023@gmail.com</a></p>
    </div>
  );
};

export default TermsAndConditions;
